export default __webpack_public_path__ + "static/media/header-mobile.2bd9f428.mp4";